module.exports = "pegasus_template/assets/blocks/header-6-theme5.png";